export const DocumentReference_DocStatus = {
    preliminary: 'preliminary',
    final: 'final',
    amended: 'amended',
    'entered-in-error': 'amended',
};
//# sourceMappingURL=types.js.map